// Polyfill for URL.parse() and URL.canParse() for Safari 17.6 compatibility
// https://github.com/mozilla/pdf.js/issues/18497

// @ts-ignore - not yet in lib.dom.d.ts
if (!URL.parse) {
  /** @type {(url: string, base?: string) => URL | null} */
  // @ts-ignore - not yet in lib.dom.d.ts
  URL.parse = function (url, base) {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

if (!URL.canParse) {
  /** @type {(url: string, base?: string) => boolean} */
  URL.canParse = function (url, base) {
    try {
      new URL(url, base);
      return true;
    } catch {
      return false;
    }
  };
}
